import { render, staticRenderFns } from "./NoteRich.vue?vue&type=template&id=3c91e71e&scoped=true"
import script from "./NoteRich.vue?vue&type=script&lang=js"
export * from "./NoteRich.vue?vue&type=script&lang=js"
import style0 from "./NoteRich.vue?vue&type=style&index=0&id=3c91e71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c91e71e",
  null
  
)

export default component.exports